
/**
 * Adds thousands separators to the integer part of a number, leaving any
 * fractional digits untouched.
 *
 * @param {number|string|null|undefined} x The value to format.
 * @returns {string|undefined} The grouped value, or undefined when x is missing.
 */
export const numberWithCommas = (x) => {
	if (x === null || x === undefined) {
		return undefined;
	}

	const [integerPart, fractionPart] = x.toString().split('.');
	const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	return fractionPart === undefined ? grouped : `${grouped}.${fractionPart}`;
};

export const getLine = (title, totals) => {
	if (totals) {
		return totals.find(row => row.title === title);
	}
}

/**
 * Combines the two ECB sources' figures into the single ECB Violations value.
 *
 * Math.max/Math.min return NaN when either side is missing (totals not loaded
 * yet, or one line absent), so a missing side defers to the one present.
 *
 * @param {number|undefined} ecbOpenData The DOB NOW (Open Data) figure.
 * @param {number|undefined} ecbBIS The BIS figure.
 * @param {function(number, number): number} pick Math.max or Math.min.
 * @returns {number|undefined} The combined figure, or undefined when both are missing.
 */
const combineEcb = (ecbOpenData, ecbBIS, pick) => {
	if (ecbOpenData === undefined || ecbOpenData === null) {
		return ecbBIS;
	}
	if (ecbBIS === undefined || ecbBIS === null) {
		return ecbOpenData;
	}

	return pick(ecbOpenData, ecbBIS);
};

//todo: dont use array index

export const getPenalties = (totals) => {
	// let ecbOpenDataPenalties = totals?.[0]?.totalPenalties;
	// let ecbBISPenalties = totals?.[1]?.totalPenalties;
	let ecbOpenData = getLine('od-ecb-violations', totals)?.totalPenalties;
	let ecbBIS =  getLine('bis-ecb-violations', totals)?.totalPenalties;
	let citypay = getLine('citypay-tickets', totals)?.totalPenalties;
	let facades = getLine('facade-filings', totals)?.totalPenalties;
	let electrical = getLine('electrical-permit-applications', totals)?.totalPenalties;
	let total = getLine('property-total', totals)?.totalPenalties;

	let penalties = {
		ecb: combineEcb(ecbOpenData, ecbBIS, Math.max),
		ecbOpenData,
		ecbBIS,
		citypay,
		facades,
		electrical,
		total,
	};

	return penalties;
};

export const getRefunds = (totals) => {
	// let ecbOpenDataRefunds = totals?.[0]?.totalRefunds;
	// let ecbBISRefunds = totals?.[1]?.totalRefunds;

	let ecbOpenData = getLine('od-ecb-violations', totals)?.totalRefunds;
	let ecbBIS =  getLine('bis-ecb-violations', totals)?.totalRefunds;
	let citypay = getLine('citypay-tickets', totals)?.totalRefunds;
	let facades = getLine('facade-filings', totals)?.totalRefunds;
	let electrical = getLine('electrical-permit-applications', totals)?.totalRefunds;
	let total = getLine('property-total', totals)?.totalRefunds;

	let refunds = {
		// Refunds are recorded as non-positive amounts, so the larger refund is
		// the more negative one -- Math.min, not Math.max (which would pick
		// whichever is closer to zero, i.e. the smaller refund). Mirrors the
		// backend's property-total, which combines the two ECB sources the
		// same way (min()) for the same reason.
		ecb: combineEcb(ecbOpenData, ecbBIS, Math.min),
		ecbOpenData,
		ecbBIS,
		citypay,
		facades,
		electrical,
		total,
	};

	return refunds;
};
